// actionTypes.js
export const REQUEST_START = 'REQUEST_START'
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'
export const REQUEST_FAILURE = 'REQUEST_FAILURE'
export const REQUEST_RETRY = 'REQUEST_RETRY'
export const REMOVE_ERROR = 'REMOVE_ERROR'
export const RESET_STATE = 'RESET_STATE'